import { render, staticRenderFns } from "./PendingData.vue?vue&type=template&id=94e2e6e2&scoped=true"
import script from "./PendingData.vue?vue&type=script&lang=js"
export * from "./PendingData.vue?vue&type=script&lang=js"
import style0 from "./PendingData.vue?vue&type=style&index=0&id=94e2e6e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94e2e6e2",
  null
  
)

export default component.exports